export default "/images/start-icon-last-1.svg?2db06db0db327b115805b8239aa66ce0";